import { Response } from '@/interfaces/api';
import { LoanDetailsData } from '@/interfaces/loan';
import api from '~/api/client';
import { CONSUMER_API_PATH } from './config';
import { PaymentOption } from '@/interfaces/payment-options';
import { getLoanNumber } from '@/storage';
import { AchProviders } from '@/constants/payments';

export function getLoanInfo(loanNumber?: string): Response<LoanDetailsData> {
  const loan = loanNumber || getLoanNumber();
  return api.client.get(`${CONSUMER_API_PATH}/loans/${loan}/`);
}

export function submitOneTimePayment(
  amount: number,
  payment_option: PaymentOption,
  loanNumber?: string,
  achProvider = AchProviders.Crb,
): Response<{ payment_id: string; }> {
  const loan = loanNumber || getLoanNumber();
  if (payment_option.type === 'bank' && achProvider === AchProviders.Crb) {
    return api.client.post(`${CONSUMER_API_PATH}/transfers/${loan}/bank-account/`, { amount });
  }

  return api.client.post(`${CONSUMER_API_PATH}/transfers/${loan}/`, { amount, payment_option });
}
